export function getLanguage() {
  const supportedLanguages = ['en', 'de'];
  const defaultLangauge = supportedLanguages[1];

  let locale =
    (navigator.languages && navigator.languages.length && navigator.languages[0].slice(0, 2)) || defaultLangauge;
  if (!supportedLanguages.some((e) => e === locale)) locale = 'en';

  return locale;
}

export default getLanguage;



// WEBPACK FOOTER //
// ./src/helpers/getLanguage.js